import { render, staticRenderFns } from "./mineDetail.vue?vue&type=template&id=08791e96&scoped=true&"
import script from "./mineDetail.vue?vue&type=script&lang=js&"
export * from "./mineDetail.vue?vue&type=script&lang=js&"
import style0 from "./mineDetail.vue?vue&type=style&index=0&id=08791e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08791e96",
  null
  
)

export default component.exports